import { Resource as a, API as i } from "@coveo/platform-client";
const e = class e extends a {
  get(t) {
    return this.api.get(`${e.baseUrl}/${t}`);
  }
  list(t) {
    return this.api.get(
      this.buildPath(e.baseUrl, t)
    );
  }
  create(t) {
    return this.api.post(e.baseUrl, { name: t });
  }
  edit(t, s) {
    return this.api.put(`${e.baseUrl}/${t}`, { name: s });
  }
  delete(t) {
    return this.api.delete(`${e.baseUrl}/${t}`);
  }
};
e.baseUrl = `/rest/organizations/${i.orgPlaceholder}/answer/v1/configs`;
let r = e;
export {
  r as AnswerConfigurationResource
};
//# sourceMappingURL=AnswerConfiguration.js.map
